import * as axios from "axios";
//import * as miscService from "../services/Misc";
import { Navigate } from "react-router-dom";

axios.interceptors.request.use(
  function (config) {
    //miscService.showpreloader();
    return config;
  },
  function (error) {
    console.log("error", error);
    //miscService.hidepreloader();
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  function (response) {
    //miscService.hidepreloader();
    return response;
  },
  function (error) {
    if (error && error.message) {
      if (error.message.includes(401)) {
        localStorage.clear();
        return <Navigate to={"/login"} />;
      }
    }
    //miscService.hidepreloader();
    return Promise.reject(error);
  },
);
const post = async (url = "", data, token = false) => {
  console.log("Post URL ", url);
  if (token) {
    token = "Bearer " + token;
  }
  let response = await axios.post(url, data, {
    headers: { Authorization: token },
  });
  return response.data;
};
const put = async (url = "", data, token = false) => {
  if (token) {
    token = "Bearer " + token;
  }

  let response = await axios.put(url, data, {
    headers: { Authorization: token },
  });
  return response.data;
};
const get = async (url = "", token = false) => {
  if (token) {
    token = "Bearer " + token;
  }
  let response = await axios.get(url, { headers: { Authorization: token } });
  return response.data;
};
const deleteData = async (url = "", token = false, body = {}) => {
  if (token) {
    token = "Bearer " + token;
  }
  let response = await axios.delete(url, {
    headers: { Authorization: token },
    data: body,
  });
  return response.data;
};

const postWithFormData = async (url = "", formData = {}, token = false) => {
  if (token) {
    token = "Bearer " + token;
  }
  const response = await axios.post(url, formData, {
    headers: { "Content-Type": "multipart/form-data", Authorization: token },
  });
  return response.data;
};
export const postDownload = async (
  url = "",
  data = {},
  token = false,
  fallbackFilename = "download",
) => {
  const headers = {};
  if (token) headers["Authorization"] = "Bearer " + token;

  const response = await axios.post(url, data, {
    headers,
    responseType: "blob", // ← key: tell axios to treat the body as binary
  });
  let filename = fallbackFilename;
  const disposition = response.headers["content-disposition"];
  if (disposition) {
    const match = disposition.match(/filename="?([^";\n]+)"?/);
    if (match?.[1]) filename = match[1].trim();
  }
  const contentType = response.headers["content-type"] || "";
  if (!filename.includes(".")) {
    if (contentType.includes("zip")) filename += ".zip";
    else if (contentType.includes("csv")) filename += ".csv";
  }

  const blobUrl = URL.createObjectURL(
    new Blob([response.data], { type: contentType }),
  );
  const anchor = document.createElement("a");
  anchor.href = blobUrl;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(blobUrl);

  return { success: true };
};

export { post, get, deleteData, put, postWithFormData };
